"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _hooks = require("../../hooks");

var Select = function Select(props) {
  var _useClassNames = (0, _hooks.useClassNames)(props),
      className = _useClassNames.className,
      classNames = _useClassNames.classNames,
      onChange = _useClassNames.onChange,
      value = _useClassNames.value,
      multiple = _useClassNames.multiple,
      disabled = _useClassNames.disabled,
      loading = _useClassNames.loading,
      options = _useClassNames.options,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_useClassNames, ["className", "classNames", "onChange", "value", "multiple", "disabled", "loading", "options"]);

  var handleChange = (0, _react.useCallback)(function (value, options) {
    if (value) {
      if (multiple) {
        onChange(value.map(function (_ref) {
          var value = _ref.value;
          return value;
        }), options);
      } else {
        onChange(value.value, options);
      }
    } else {
      onChange(value, options);
    }
  }, [multiple, onChange]);
  var currentValue = (0, _react.useMemo)(function () {
    if (value) {
      if (multiple) {
        return value.map(function (currentValue) {
          return options && options.find(function (_ref2) {
            var value = _ref2.value;
            return value === currentValue;
          }) || {
            value: currentValue,
            label: currentValue
          };
        });
      } else {
        return options && options.find(function (_ref3) {
          var optionValue = _ref3.value;
          return optionValue === value;
        }) || {
          value: value,
          label: value
        };
      }
    } else if (multiple) {
      return [];
    } else {
      return undefined;
    }
  }, [value, multiple, options]);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.default, (0, _extends2.default)({
    value: currentValue,
    options: options,
    isMulti: multiple,
    isLoading: loading,
    isDisabled: disabled,
    onChange: handleChange,
    classNamePrefix: props.alias,
    className: props.alias + "___container"
  }, restProps));
};

Select.propTypes = (0, _extends2.default)({
  alias: _propTypes.default.string,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]))]),
  multiple: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    label: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.node])
  }))
}, _reactSelect.default.propTypes);
Select.defaultProps = {
  alias: 'Select',
  // TODO fixme
  options: [],
  placeholder: ''
};
Select.displayName = 'Select';
var _default = Select;
exports.default = _default;